import script from "./TwoDModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoDModal.vue?vue&type=script&setup=true&lang=ts"

import "./TwoDModal.vue?vue&type=style&index=0&id=7670ff75&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7670ff75"]])

export default __exports__